import React from 'react';
import { FaRobot } from 'react-icons/fa';
import TwitchUserCard from './TwitchUserCard';
import EmptyUserCard from './EmptyUserCard';
import { HOME_TEXTS, APP_BUTTON_STYLES } from './constants';

/**
 * Props pour le composant TwitchAppCard
 * @typedef {Object} TwitchAppCardProps
 * @property {Object|null} twitchApp - L'application Twitch de l'utilisateur
 * @property {Function} onDashboard - Fonction appelée pour naviguer vers le dashboard
 * @property {Function} onProfile - Fonction appelée pour naviguer vers le profil
 * @property {Function} onEdit - Fonction appelée pour éditer l'application
 * @property {Function} onSetup - Fonction appelée pour créer une nouvelle application
 */

/**
 * Composant de carte pour l'application Twitch
 * Affiche soit une carte avec les informations de l'application, soit une carte vide pour créer une nouvelle application
 *
 * @component
 * @param {TwitchAppCardProps} props - Les props du composant
 * @returns {JSX.Element} La carte de l'application Twitch
 */
const TwitchAppCard = ({
  twitchApp,
  onDashboard,
  onProfile,
  onEdit,
  onSetup,
}) => {
  if (twitchApp) {
    return (
      <TwitchUserCard
        user={{
          id: twitchApp.id,
          display_name: twitchApp.isSystemApp
            ? twitchApp.twitchUser?.display_name || twitchApp.appName
            : twitchApp.appName,
          login: twitchApp.isSystemApp
            ? twitchApp.twitchUser?.login || twitchApp.appName
            : twitchApp.appName,
          appType: 'twitch-app',
        }}
        onGoToDashboard={onDashboard}
        onNavigateProfile={onProfile}
        onEdit={onEdit}
        isAppCard={true}
        appData={twitchApp}
        twitchUser={twitchApp.twitchUser}
      />
    );
  }

  return (
    <EmptyUserCard
      platform="TwitchApp"
      icon={FaRobot}
      title={HOME_TEXTS.TWITCH_APP.TITLE}
      description={HOME_TEXTS.TWITCH_APP.DESCRIPTION}
      buttonText={HOME_TEXTS.TWITCH_APP.BUTTON}
      onLogin={onSetup}
      buttonStyle={APP_BUTTON_STYLES.TWITCH}
    />
  );
};

export default TwitchAppCard;
